module.exports = __webpack_public_path__ + "img/Differentiation-MELA_GSE185386.81cd9246.png";